import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const getUserRoleMenu = () => {
  return apiRequestType(apiTypes.GET, apiConstants.COMMON.GET_USER_ROLE_MENU);
};

export default getUserRoleMenu;
